<div class="mainContainer card overflow-auto margin mt-4">
    <div class="loader" *ngIf="loading">
        <mat-spinner diameter="30"></mat-spinner>
    </div>
    <div class="reminder mb-0 d-flex bg-light justify-content-between flex-column flex-sm-row">
        <h5 class="card-title ps-4 mb-0 tableTitle"> {{totalCount}} Job(s)</h5>
        <div class="form-inline ms-auto me-4 d-none d-md-flex hstack card-title ps-4 mb-0">
            <div class="input-group input-group-sm input-group-inline"><span class="input-group-text pe-2"><i
                class="bi bi-search"></i> </span><input type="email" class="form-control" placeholder="Search Jobs"
              aria-label="Search" [(ngModel)]="jobSearch" (keyup)="searchJob()">
          </div>
        </div>
    </div>
    <table matSort (matSortChange)="sortData($event)" class="table table-hover table-nowrap">
        <thead class="table-light">
          <tr>
            <th mat-sort-header="title" scope="col" class="ps-5">Name</th>
            <th mat-sort-header="title" scope="col" class="ps-5">Client</th>
            <th mat-sort-header="title" scope="col" class="ps-5">Contractors</th>
            <th mat-sort-header="pay_rate" scope="col">Rates (Pay/Bill)</th>
            <th mat-sort-header="positions" scope="col">Positions</th>
            <th mat-sort-header="start_date" scope="col">Dates</th>
            <th mat-sort-header="end_date" scope="col">End Date</th>
            <th mat-sort-header="created_at" scope="col">Created At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
            <tr *ngFor="let job of allJobs"  style="cursor: pointer;" class="dataColumn">
                <td (click)="openAuditTrail(job)">
                  <div class="textWithIcon" matTooltip="{{job.description ?? '--'}}" [matTooltipPosition]="'below'">
                    <i class="bi bi-briefcase"></i>
                    <span class="text-heading font-semibold">{{job.title}}</span>
                  </div>
                </td>
                <td matTooltip="{{job.location ?? '--'}}" [matTooltipPosition]="'below'">{{job.client ?? '--'}}</td>
                <td>{{job.contractors.join(', ') ?? '--'}}</td>
                <td>
                  <ng-container *ngIf="job.rates?.length; else legacyRate">
                    <div *ngFor="let rate of job.rates" class="small">
                      {{rate.rate_type_name}}: {{rate.pay_rate}}/{{rate.bill_rate}}
                    </div>
                  </ng-container>
                  <ng-template #legacyRate>{{job.pay_rate ?? '--'}}/{{job.bill_rate ?? '--'}}</ng-template>
                </td>
                <td>{{job.positions ?? '--'}}</td>
                <td>{{dataSharedService.tranformDate(job.start_date)}}</td>
                <td>{{dataSharedService.tranformDate(job.end_date)}}</td>
                <td>{{dataSharedService.tranformDate(job.created_at)}}</td>
                <td>
                  <div style="color: #6b7b93;" class="btn btn-neutral btn-sm bt-square ms-1 px-3 py-1 fs-7" matTooltip="Edit" [matTooltipPosition]="'left'" (click)="onEdit(job)">
                    <i class="bi bi-pencil"></i>
                  </div>
                  <div *ngIf="user?.role_uuid === ROLES?.AGENCY && job.contract == null &&  job.status !== 4"  class="btn btn-neutral btn-sm bt-square ms-1 px-3 py-1 fs-7" matTooltip="Send Contract" [matTooltipPosition]="'left'" (click)="onEdit(job, true)">
                    <i class="bi bi-c-square"></i>
                  </div>
                  <div *ngIf="user?.role_uuid === ROLES?.AGENCY || user?.role_uuid === ROLES?.CLIENT" class="btn btn-neutral btn-sm bt-square ms-1 px-3 py-1 fs-7" (click)="inactivateJob(job.uuid)" matTooltip="Deactivate job" [matTooltipPosition]="'left'">
                    <i class="bi bi-lock"></i>
                  </div>
                  <div *ngIf="(user?.role_uuid === ROLES?.AGENCY || user?.role_uuid === ROLES?.SUPER_ADMIN) && job.on_boarding_form && job.is_job_active_once" class="btn btn-neutral btn-sm bt-square ms-1 px-3 py-1 fs-7" (click)="viewOnBoardingFormDetails(job)" matTooltip="View Onboarding Form Details Submitted By Candidate" [matTooltipPosition]="'left'">
                    <i class="bi bi-eye"></i>
                  </div>                
                </td>
              </tr>
        </tbody>
    </table>
    <app-api-paginator *ngIf="totalCount" [totalCount]="totalCount" (onStepChange)="onStepChange($event)">
      </app-api-paginator>
</div>